import { render, staticRenderFns } from "./PlatonLink.vue?vue&type=template&id=48491720&"
import script from "./PlatonLink.vue?vue&type=script&lang=js&"
export * from "./PlatonLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports